import { render, staticRenderFns } from "./purchaseReturn-add-or-update.vue?vue&type=template&id=1b1a07c4&scoped=true"
import script from "./purchaseReturn-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseReturn-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturn-add-or-update.vue?vue&type=style&index=0&id=1b1a07c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1a07c4",
  null
  
)

export default component.exports